import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/query/queryKeys'
import { isApiConfigured } from '@/config/api/env'
import { fetchToolkits, fetchToolkitCategories } from '@/services/integrations'

/** The connectable app catalogue. Rarely changes; cached for the session. */
export function useToolkits() {
  return useQuery({
    queryKey: queryKeys.integrations.toolkits,
    queryFn: ({ signal }) => fetchToolkits({ signal }),
    enabled: isApiConfigured(),
    staleTime: 10 * 60_000,
  })
}

/** Live categories for the modal sidebar. */
export function useToolkitCategories() {
  return useQuery({
    queryKey: queryKeys.integrations.categories,
    queryFn: ({ signal }) => fetchToolkitCategories({ signal }),
    enabled: isApiConfigured(),
    staleTime: 10 * 60_000,
  })
}
